import { useTranslations } from 'next-intl';
import { CatButton, CatPagination } from 'components/blocks-components';
import styles from '../saved-list-drawer.module.scss';
import { RowSelectionState, Table } from '@tanstack/react-table';
import { SavedList } from 'services/savedLists/types';
import { DEFAULT_SAVED_LISTS_PER_PAGE } from 'app/[lang]/[esite]/(core)/cart/_components/quick-order-section/quick-order-form/constants';
import { useCallback } from 'react';

export const SavedListDrawerFooter = ({
  onCloseDrawer,
  onActionDrawer,
  table,
  confirmBtnText
}: Readonly<{
  onCloseDrawer: () => void;
  onActionDrawer?: (rowSelected: RowSelectionState) => void;
  table: Table<SavedList>;
  confirmBtnText: string;
}>) => {
  const t = useTranslations();
  const totalRecords = table.getFilteredRowModel().rows.length;
  const currentItem = table.getState().pagination.pageIndex + 1;
  const savedListRowSelected = table.getState().rowSelection;
  const isEnabled = Object.keys(savedListRowSelected).length > 0;

  const handlePageChange = ({ detail }) => {
    const { pageNumber } = detail;
    table.setPageIndex(pageNumber - 1);
  };
  const handleAddClick = useCallback(() => {
    onActionDrawer(savedListRowSelected);
  }, [onActionDrawer, savedListRowSelected]);
  const paginationLabel = (limit, page, totalResultsCount) =>
    t('ORGANIZATIONUSERSLIST_PAGE_DISPLAY2', {
      0: `${page * limit - limit + 1}`,
      1: `${
        page * limit < totalResultsCount ? page * limit : totalResultsCount
      }`,
      2: `${totalResultsCount}`
    });
  return (
    <div
      className={`d-flex align-items-center ${styles['saved-list-drawer__footer']}`}
    >
      <span className="d-md-none d-flex">
        <CatButton
          variant="primary"
          onClick={handleAddClick}
          disabled={!isEnabled}
        >
          {confirmBtnText}
        </CatButton>
      </span>
      <span className="d-md-flex d-none">
        <CatButton
          size="lg"
          variant="primary"
          onClick={handleAddClick}
          disabled={!isEnabled}
        >
          {confirmBtnText}
        </CatButton>
      </span>
      <CatButton onClick={onCloseDrawer} variant="ghost">
        {t('CANCEL')}
      </CatButton>
      <CatPagination
        data-testid="saved-list-pagination"
        className={`${styles['saved-list-drawer__pagination']}`}
        variant={'in-page'}
        totalRecords={totalRecords}
        currentItem={currentItem}
        pageSize={DEFAULT_SAVED_LISTS_PER_PAGE}
        onBlPageChange={handlePageChange}
      >
        <div slot="inpage-label">
          {paginationLabel(
            DEFAULT_SAVED_LISTS_PER_PAGE,
            currentItem,
            totalRecords
          )}
        </div>
      </CatPagination>
    </div>
  );
};
